(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gb-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gb-trust"] && !Shopify.designMode) return;
  try {
    
  // Reveals GB · Güven columns as they scroll into view. Deliberately dependency-free and
  // opt-in: the `data-gb-reveal-ready` flag (which is what actually hides the items) is only
  // set once we know the observer can run, so a failure here leaves the content visible.
  (() => {
    const REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (REDUCED || !('IntersectionObserver' in window)) return;

    const setup = (section) => {
      if (section.dataset.gbRevealBound) return;
      section.dataset.gbRevealBound = '1';
      if (!section.hasAttribute('data-gb-animate')) return;

      const items = section.querySelectorAll('.gb-trust__item');
      if (!items.length) return;

      section.setAttribute('data-gb-reveal-ready', '');

      const reveal = (el) => el.classList.add('is-revealed');

      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            reveal(entry.target);
            io.unobserve(entry.target);
          });
        },
        { rootMargin: '0px 0px -12% 0px', threshold: 0.15 }
      );

      items.forEach((item) => {
        // Anything already on screen (or scrolled past on a deep link) reveals immediately
        // rather than waiting for an intersection that has already happened.
        const box = item.getBoundingClientRect();
        if (box.top < window.innerHeight && box.bottom > 0) reveal(item);
        else io.observe(item);
      });

      // Last-resort guard: hiding is driven by CSS, so anything still unrevealed after a
      // few seconds gets shown regardless. Content must never be stuck invisible because
      // an observer failed to fire.
      window.setTimeout(() => {
        items.forEach(reveal);
        io.disconnect();
      }, 4000);
    };

    const run = () => document.querySelectorAll('.gb-trust').forEach(setup);
    run();
    // Theme editor re-renders the section on every setting change.
    document.addEventListener('shopify:section:load', run);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
